/* Campaign defaults. Shopify Liquid supplies verified native mappings and availability. */
window.LYNK_CHRISTMAS_DATA = {
  storageKey: 'lynk-christmas-2026-v12',
  scents: {
    'white-tea': {
      name: 'White Tea', notes: 'Bergamot + jasmine', feeling: 'calm',
      opening: 'The first quiet morning.',
      reason: 'For a little unhurried time: bright bergamot and the soft floral presence of jasmine.',
      productMappings: {},
      standardProducts: {
        candle: 'https://lynkfragrances.com/products/white-tea-candle?variant=33011711541332',
        diffuser: 'https://lynkfragrances.com/products/white-tea-reed-diffuser?variant=51422871486762',
        'poo-fighters': 'https://lynkfragrances.com/products/white-tea-poo-fighters?variant=39642579140692'
      }
    },
    'firlight-noel': {
      name: 'Firlight Noël', notes: 'Fir + amber', feeling: 'welcome',
      opening: 'The house everyone comes back to.',
      reason: 'For the person who makes room for everyone: green fir and the enveloping warmth of amber.',
      productMappings: {}, standardProducts: {}
    },
    'christmas-eve-latte': {
      name: 'Christmas Eve Latte', notes: 'Lavender + tonka', feeling: 'cosy',
      opening: 'The night belongs to you.',
      reason: 'For the end of a full day: aromatic lavender and the rounded warmth of tonka.',
      productMappings: {}, standardProducts: {}
    }
  },
  formats: {
    candle: { name: 'Scented candle', size: '150g', ritual: 'A moment to linger.' },
    diffuser: { name: 'Reed diffuser', size: '50ml', ritual: 'A home to return to.' },
    'poo-fighters': { name: 'Poo Fighters', size: '30ml', ritual: 'An everyday bathroom ritual.', detail: 'Dropper bottle' }
  },
  giftSets: {
    "little-thought": {
      "name": "The Christmas Trio",
      "description": "Three Christmas scents, ready to share.",
      "price": "$19.90 SGD",
      "amount": 1990,
      "currency": "SGD",
      "contents": [
        "3 Christmas hand sanitisers, one of each scent",
        "1 organza bag",
        "1 greeting card"
      ],
      "formats": [],
      "scentMode": "all-three",
      "image": "/assets/lynk-gift-sets-v34-sanitiser-trio.webp",
      "imageCaption": "Includes White Tea, Firlight Noël and Christmas Eve Latte."
    },
    "home-to-return": {
      "name": "The Everyday Escape",
      "description": "A few everyday essentials, ready to gift.",
      "price": "$38.70 SGD",
      "amount": 3870,
      "currency": "SGD",
      "contents": [
        "1 hand sanitiser",
        "1 Poo Fighter · 30ml",
        "1 shower steamer · 50g",
        "1 ambience diffuser box, packaging only",
        "1 greeting card"
      ],
      "formats": [],
      "scentMode": "components",
      "image": "/assets/lynk-gift-sets-v34-everyday-escape.webp",
      "imageCaption": "Scents shown: Christmas Eve Latte sanitiser and Firlight Noël Poo Fighter.",
      "components": [
        {
          "key": "sanitiser",
          "label": "Hand sanitiser scent",
          "optionName": "Sanitiser scent",
          "values": [
            "White Tea",
            "Firlight Noël",
            "Christmas Eve Latte"
          ]
        },
        {
          "key": "poo",
          "label": "Poo Fighter scent",
          "optionName": "Poo Fighter scent",
          "values": [
            "White Tea",
            "Firlight Noël",
            "Christmas Eve Latte"
          ]
        },
        {
          "key": "steamer",
          "label": "Shower steamer scent · 50g",
          "optionName": "Shower steamer scent",
          "values": [
            "Lavender Fields in Provence (Lavender)",
            "California Mornings (Mandarin + Garden Mint)",
            "Rose Blush (Rose & Amber)",
            "Geranium Eucalyptus",
            "Lavender Rosemary",
            "White Tea",
            "Sinus Relief",
            "Green Tea & Cassis"
          ]
        }
      ]
    },
    "christmas-ritual": {
      "name": "The Home Ritual",
      "description": "A candle and diffuser for home, ready to gift.",
      "price": "$49.80 SGD",
      "amount": 4980,
      "currency": "SGD",
      "contents": [
        "1 scented candle · 150g",
        "1 reed diffuser · 50ml",
        "1 ambience diffuser box",
        "1 greeting card"
      ],
      "formats": [],
      "scentMode": "components",
      "image": "/assets/lynk-gift-sets-v34-home-ritual.webp",
      "imageCaption": "Scents shown: Christmas Eve Latte candle and Firlight Noël diffuser.",
      "components": [
        {
          "key": "candle",
          "label": "Candle scent · 150g",
          "optionName": "Candle scent",
          "values": [
            "White Tea",
            "Firlight Noël",
            "Christmas Eve Latte"
          ]
        },
        {
          "key": "diffuser",
          "label": "Reed diffuser scent · 50ml",
          "optionName": "Diffuser scent",
          "values": [
            "White Tea",
            "Firlight Noël",
            "Christmas Eve Latte"
          ]
        }
      ]
    }
  },
  /* Only an actual bundle product variant may enable a set's Shopify purchase. */
  giftSetMappings: { 'little-thought': {}, 'home-to-return': {}, 'christmas-ritual': {} },
  recipients: { mum: 'Mum', loved: 'Someone I love', friend: 'A friend', myself: 'Myself' },
  feelings: {
    calm: { label: 'A little calm', scent: 'white-tea' },
    welcome: { label: 'A warm welcome', scent: 'firlight-noel' },
    cosy: { label: 'A cosy moment', scent: 'christmas-eve-latte' }
  },
  letter: 'Thank you for all the little things we were too young to notice.\nFor putting us first. For giving so much of yourself. For always making sure we were okay.\n\nThis Christmas, let us look after you.\n\nWe love you. Always.',
  letterTemplates: {
    loved: { to: 'Someone special', message: 'Thank you for all the ways you make life feel a little brighter.\n\nThis Christmas, I wanted to give you a little moment that is just for you.\n\nWith you in mind, always.' },
    friend: { to: 'My friend', message: 'Thank you for the laughter, the check-ins and the ordinary days made better by your company.\n\nHere’s a little Christmas thought, chosen just for you.\n\nI’m so glad you’re in my life.' },
    myself: { to: 'Me', message: 'A little reminder to make room for myself, too.\n\nThis Christmas, I can pause, enjoy the small things and choose a moment that is mine.\n\nWith a little kindness to myself.' }
  },
  chapters: {
    making: { src: 'assets/story-making.webp', alt: 'Painted storyboard: Singapore and two fictional aunties preparing Christmas gifts in their workshop.', caption: 'In our imagined workshop, the aunties prepare gifts with care. Read left to right, then down.' },
    departure: { src: 'assets/story-departure.webp', alt: 'Painted storyboard: the aunties hand the gifts to Santa and his elves for a journey over Singapore.', caption: 'Santa and his elves take the gifts on a journey above Singapore.' },
    ending: { src: 'assets/story-ending.webp', alt: 'Painted storyboard: a gift reaches a Singapore home, a daughter welcomes Mum, and a letter leads to an embrace.', caption: 'At a Singapore home, someone has remembered the person who always puts everyone else first. For Mum.' }
  }
};

(function(){const source=document.currentScript.src;Object.values(window.LYNK_CHRISTMAS_DATA.chapters||{}).forEach(chapter=>{chapter.src=new URL(chapter.src,source).href;});window.LYNK_CHRISTMAS_DATA.assets={courtyard:new URL('assets/singapore-sky.webp',source).href};}());

/* Supply only an approved, actual film URL. An empty URL keeps the honest placeholder. */
window.LYNK_CAMPAIGN = Object.assign({
  filmSrc: '',
  filmPoster: 'assets/christmas-film-poster.webp'
}, window.LYNK_CAMPAIGN || {});

window.LYNK_CAMPAIGN.filmPoster=new URL(window.LYNK_CAMPAIGN.filmPoster,document.currentScript.src).href;

(function () {
  'use strict';

  const instances = window.__lynkChristmasInstances || new WeakMap();
  window.__lynkChristmasInstances = instances;
  let serial = window.__lynkChristmasSerial || 0;
  const blockedKeys = new Set(['__proto__', 'prototype', 'constructor']);
  const isRecord = value => value && typeof value === 'object' && !Array.isArray(value);
  function merge(base, extra) {
    const result = { ...base };
    if (!isRecord(extra)) return result;
    Object.keys(extra).forEach(key => {
      if (blockedKeys.has(key)) return;
      result[key] = isRecord(extra[key]) && isRecord(result[key]) ? merge(result[key], extra[key]) : extra[key];
    });
    return result;
  }
  function safeUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, document.baseURI);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }
  function element(tag, className, text) {
    const item = document.createElement(tag);
    if (className) item.className = className;
    if (text !== undefined) item.textContent = text;
    return item;
  }

  function actionLink(tag, className, label) {
    const item = element(tag, className, label.replace(/[\s↗\uFE0F]+$/u, '').trim());
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [key, value] of Object.entries({class:'lc-icon',width:'20',height:'20',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.5','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) icon.setAttribute(key, value);
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    line.setAttribute('d', 'M6 18 18 6M6 6h12v12'); icon.append(line);
    item.append(document.createTextNode(' '), icon); return item;
  }

  window.initLynkChristmas = function initLynkChristmas(root) {
    if (!(root instanceof Element)) return null;
    instances.get(root)?.destroy();
    if (!window.LYNK_CHRISTMAS_DATA) return null;
    const controller = new AbortController();
    const { signal } = controller;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => Array.from(root.querySelectorAll(selector));
    const on = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal });
    let overrides = {};
    const dataScript = $('script[data-lynk-data]');
    if (dataScript) {
      try { overrides = JSON.parse(dataScript.textContent); }
      catch (_) { root.dataset.configError = 'Invalid campaign configuration'; }
    }
    const data = merge(merge(window.LYNK_CHRISTMAS_DATA, root.lynkChristmasData || {}), overrides);
    const ui = data.ui || {};
    const text = (key, fallback, values = {}) => {
      let output = typeof ui[key] === 'string' ? ui[key] : fallback;
      Object.entries(values).forEach(([name, value]) => { output = output.replaceAll('{' + name + '}', String(value)); });
      return output;
    };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scents = data.scents;
    const formats = data.formats;
    const giftSets = data.giftSets || {};
    const recipients = data.recipients;
    const feelings = data.feelings;
    /* The two routes share editable labels without changing their stable IDs. */
    if (data.mode === 'shopify') {
      const setLeadingText = (container, value) => {
        if (!container || typeof value !== 'string') return;
        const first = container.firstChild;
        if (first?.nodeType === 3) first.textContent = value;
        else container.prepend(document.createTextNode(value));
      };
      $$('[data-feeling]').forEach(button => {
        setLeadingText(button.querySelector('span'), feelings[button.dataset.feeling]?.label);
      });
      $$('[data-finder-choice="feeling"]').forEach(input => {
        setLeadingText(input.nextElementSibling, feelings[input.value]?.label);
      });
      $$('[data-finder-choice="tier"]').forEach(input => {
        const summary = input.closest('label')?.querySelector('small');
        const tier = giftSets[input.value];
        if (summary && tier) summary.textContent = tierContents(tier).join(' + ');
      });
    }
    const letterTemplates = merge({ mum: { to: 'Mum', message: data.letter } }, data.letterTemplates || {});
    const storageKey = data.storageKey || 'lynk-christmas-2026-v12';
    const validScent = key => Object.hasOwn(scents, key);
    const validFormat = key => Object.hasOwn(formats, key);
    const validRecipient = key => Object.hasOwn(recipients, key);
    const validFeeling = key => Object.hasOwn(feelings, key);
    const validTier = key => Object.hasOwn(giftSets, key);
    const setMode = tier => giftSets[tier]?.scentMode || 'one-scent';
    const fixedSet = tier => ['all-three', 'fixed-pictured'].includes(setMode(tier));
    const resolveSetScent = (tier, scent) => fixedSet(tier) ? 'white-tea' : scent;
    const componentSet = tier => setMode(tier) === 'components';
    const componentSpecs = tier => Array.isArray(giftSets[tier]?.components) ? giftSets[tier].components : [];
    function componentChoices(tier, values) {
      return Object.fromEntries(componentSpecs(tier).map(part => [part.key, isRecord(values) && part.values.includes(values[part.key]) ? values[part.key] : '']));
    }
    const completeChoices = (tier, choices) => componentSpecs(tier).length > 0 && componentSpecs(tier).every(part => part.values.includes(choices?.[part.key]));
    const choiceKey = (tier, choices) => JSON.stringify(componentSpecs(tier).map(part => componentChoices(tier, choices)[part.key]));
    function componentMapping(tier, choices) {
      const source = data.boxedSetProducts?.[tier], parts = componentSpecs(tier);
      if (!source?.configured || !completeChoices(tier, choices) || !Array.isArray(source.variants) || !Array.isArray(source.optionNames)) return undefined;
      if (!Number.isInteger(source.variantCount) || source.variantCount < 1 || source.variantCount > 250 || source.variantCount !== source.serializedCount || source.serializedCount !== source.variants.length) return undefined;
      if (source.optionNames.length !== parts.length || new Set(source.optionNames).size !== parts.length || !parts.every(part => source.optionNames.includes(part.optionName))) return undefined;
      const ids = source.variants.map(row => String(row.variantId));
      if (ids.some(id => !/^\d+$/.test(id)) || new Set(ids).size !== ids.length || !/^\d+$/.test(String(source.productId))) return undefined;
      const requested = source.requestedVariantId;
      if (typeof requested !== 'string' || (requested && !/^\d+$/.test(requested))) return undefined;
      if (requested && !ids.includes(requested)) return undefined;
      const matches = source.variants.filter(row => Array.isArray(row.options) && row.options.length === parts.length && parts.every(part => row.options[source.optionNames.indexOf(part.optionName)] === choices[part.key]));
      if (matches.length !== 1) return undefined;
      const match = matches[0];
      if ((requested && String(match.variantId) !== requested) || typeof match.available !== 'boolean' || typeof match.price !== 'string' || !match.price.trim() || !Number.isInteger(match.amount) || match.amount < 0 || !safeUrl(match.url)) return undefined;
      return { ...match, productId: String(source.productId), configured: true };
    }
    function renderComponentChoices(tier) {
      const group = $('[data-set-components]');
      if (!group) return;
      group.hidden = !componentSet(tier);
      if (group.hidden) return;
      if (group.dataset.tier !== tier) {
        const legend = element('legend', '', text('v34ChooseScents', 'Choose your scents'));
        group.replaceChildren(legend);
        componentSpecs(tier).forEach(part => {
          const label = element('label', 'v34-component-choice'), caption = element('span', '', part.label), select = element('select');
          select.dataset.setComponent = part.key;
          select.name = prefix + '-set-component-' + part.key;
          select.append(new Option(text('v34ChooseScent', 'Choose a scent'), ''));
          part.values.forEach(value => select.append(new Option(value, value)));
          label.append(caption, select); group.append(label);
        });
        group.dataset.tier = tier;
      }
      group.querySelectorAll('[data-set-component]').forEach(select => { select.value = setSelection.choices?.[select.dataset.setComponent] || ''; });
    }

    function setScentLabel(tier, scent, choices) {
      if (componentSet(tier)) return completeChoices(tier, choices) ? componentSpecs(tier).map(part => part.label + ": " + choices[part.key]).join("; ") : text("v34ChooseScentsSaved", "Scents to choose — open Edit to review each product.");
      if (setMode(tier) === 'all-three') return text('v34NoSingleScent', 'All three Christmas scents');
      if (setMode(tier) === 'pending') return text('v34NoScentChoice', 'Scents shown in the photograph');
      if (setMode(tier) === 'fixed-pictured') return giftSets[tier].imageCaption || text('v34FixedScents', 'Scents as shown.');
      return scents[scent].name + ' · ' + scents[scent].notes;
    }
    const giftKey = gift => gift.kind === 'set' ? 'set:' + gift.tier + ':' + (componentSet(gift.tier) ? choiceKey(gift.tier, gift.choices) : gift.scent) : gift.scent + ':' + gift.format;
    function cleanGift(gift, strict = true) {
      if (!isRecord(gift) || typeof gift.scent !== 'string' || !validScent(gift.scent)) return null;
      if (gift.kind !== undefined && gift.kind !== 'set' && gift.kind !== 'single') return null;
      if (strict && gift.recipient !== undefined && (typeof gift.recipient !== 'string' || !validRecipient(gift.recipient))) return null;
      if (strict && gift.feeling !== undefined && (typeof gift.feeling !== 'string' || !validFeeling(gift.feeling))) return null;
      if (strict && gift.feeling !== undefined && feelings[gift.feeling].scent !== gift.scent && !(gift.kind === 'set' && (fixedSet(gift.tier) || componentSet(gift.tier)))) return null;
      const context = {
        recipient: typeof gift.recipient === 'string' && validRecipient(gift.recipient) ? gift.recipient : 'loved',
        feeling: typeof gift.feeling === 'string' && validFeeling(gift.feeling) ? gift.feeling : scents[gift.scent].feeling
      };
      if (gift.kind === 'set') {
        if (typeof gift.tier !== 'string' || !validTier(gift.tier)) return null;
        const choices = componentSet(gift.tier) ? componentChoices(gift.tier, gift.choices) : undefined;
        if (strict && componentSet(gift.tier) && gift.choices !== undefined && (!isRecord(gift.choices) || Object.entries(gift.choices).some(([key, value]) => !componentSpecs(gift.tier).some(part => part.key === key && (value === '' || part.values.includes(value)))))) return null;
        return { kind: 'set', tier: gift.tier, scent: resolveSetScent(gift.tier, gift.scent), ...(choices ? { choices } : {}), ...context };
      }
      if (typeof gift.format !== 'string' || !validFormat(gift.format)) return null;
      return { scent: gift.scent, format: gift.format, ...context };
    }
    const state = { gifts: [], setChoices: {}, letter: { to: 'Mum', from: '', message: data.letter }, letterCustomized: false, letterRecipient: 'mum' };
    let persistence = true;
    let journeyStep = 1;
    let selection = { recipient: 'loved', feeling: 'calm', scent: 'white-tea', format: 'candle' };
    let editingKey = null;
    let currentScent = validScent(root.dataset.currentScent) ? root.dataset.currentScent : 'white-tea';
    let setSelection = { tier: 'little-thought', scent: resolveSetScent('little-thought', currentScent) };
    let setEditingKey = null;
    let frame = 0;
    const animations = new Set();
    const returns = new WeakMap();
    const journey = $('[data-journey-dialog]');
    const giftDialog = $('[data-gift-dialog]');
    const letterDialog = $('[data-letter-dialog]');
    const storyDialog = $('[data-film-story-dialog]');
    const setDialog = $('[data-set-dialog]');
    if (validTier(setDialog?.dataset.tier)) setSelection.tier = setDialog.dataset.tier;
    const screens = $$('[data-journey-step]');

    /* Give each instance its own labels, anchor targets and radio groups. */
    const prefix = root.dataset.instancePrefix || ('lynk-christmas-' + (++serial));
    window.__lynkChristmasSerial = serial;
    root.dataset.instancePrefix = prefix;
    if (!root.dataset.idsScoped) {
      const idMap = new Map();
      $$('[id]').forEach(item => { idMap.set(item.id, prefix + '-' + item.id); });
      $$('[id]').forEach(item => { item.id = idMap.get(item.id); });
      $$('[aria-labelledby],[aria-describedby],[aria-controls],[for]').forEach(item => {
        ['aria-labelledby', 'aria-describedby', 'aria-controls', 'for'].forEach(attribute => {
          if (!item.hasAttribute(attribute)) return;
          item.setAttribute(attribute, item.getAttribute(attribute).split(/\s+/).map(id => idMap.get(id) || id).join(' '));
        });
      });
      $$('a[href^="#"]').forEach(link => {
        const old = link.getAttribute('href').slice(1);
        if (idMap.has(old)) link.setAttribute('href', '#' + idMap.get(old));
      });
      $$('input[type="radio"]').forEach(input => { input.name = prefix + '-' + input.name; });
      root.dataset.idsScoped = 'true';
    }

    try {
      const stored = JSON.parse(localStorage.getItem(storageKey));
      if (isRecord(stored)) {
        if (Array.isArray(stored.gifts)) {
          stored.gifts.forEach(gift => {
            const clean = cleanGift(gift, false);
            if (!clean) return;
            if (!state.gifts.some(item => giftKey(item) === giftKey(clean))) state.gifts.push(clean);
          });
        }
        if (isRecord(stored.setChoices)) Object.keys(giftSets).filter(componentSet).forEach(tier => { state.setChoices[tier] = componentChoices(tier, stored.setChoices[tier]); });
        if (isRecord(stored.letter)) {
          ['to', 'from', 'message'].forEach(key => {
            if (typeof stored.letter[key] === 'string') state.letter[key] = stored.letter[key].slice(0, key === 'message' ? 1500 : key === 'to' ? 60 : 80);
          });
          const matchesDefault = Object.values(letterTemplates).some(template => template.to === state.letter.to && template.message === state.letter.message && !state.letter.from);
          const legacyDefault = state.letter.message === data.letter && ['Mum', 'Myself'].includes(state.letter.to) && !state.letter.from;
          state.letterCustomized = stored.letterCustomized === true || !(matchesDefault || legacyDefault);
          state.letterRecipient = validRecipient(stored.letterRecipient) ? stored.letterRecipient : 'mum';
        }
      }
    } catch (_) { /* A malformed or unavailable browser store starts a clean visit. */ }

    function persist() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ version: 2, gifts: state.gifts, setChoices: state.setChoices, letter: state.letter, letterCustomized: state.letterCustomized, letterRecipient: state.letterRecipient }));
        persistence = true;
      } catch (_) { persistence = false; }
      return persistence;
    }
    function focusable(dialog) {
      return Array.from(dialog.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),textarea:not(:disabled),[tabindex="0"]')).filter(item => item.getClientRects().length && !item.closest('[hidden]'));
    }
    function openDialog(dialog, trigger, focusTarget) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      const active = trigger || document.activeElement;
      const previousDialog = active?.closest?.('dialog');
      const returnTarget = previousDialog ? returns.get(previousDialog) : active;
      $$('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
      returns.set(dialog, returnTarget);
      if (!dialog.open) dialog.showModal();
      dialog.scrollTop = 0;
      (focusTarget || dialog.querySelector('h2') || focusable(dialog)[0])?.focus({ preventScroll: true });
      return true;
    }
    $$('dialog').forEach(dialog => {
      on(dialog, 'close', () => {
        if (!root.querySelector('dialog[open]')) {
          const target = returns.get(dialog);
          if (target?.isConnected) target.focus({ preventScroll: true });
        }
      });
      on(dialog, 'keydown', event => {
        if (event.key !== 'Tab') return;
        const items = focusable(dialog);
        if (!items.length) { event.preventDefault(); return; }
        const active = document.activeElement;
        if (event.shiftKey && (active === items[0] || !items.includes(active))) {
          event.preventDefault(); items[items.length - 1].focus();
        } else if (!event.shiftKey && (active === items[items.length - 1] || !items.includes(active))) {
          event.preventDefault(); items[0].focus();
        }
      });
    });
    $$('[data-dialog-close]').forEach(button => on(button, 'click', () => button.closest('dialog')?.close()));

    function animateScene(screen) {
      if (!screen) return;
      screens.forEach(item => item.classList.remove('is-arriving'));
      const scene = $('[data-journey-scene]');
      scene?.classList.remove('is-pushing');
      if (reduced.matches) return;
      /* Restart a finite push-through. Content is always readable without animation. */
      void screen.offsetWidth;
      screen.classList.add('is-arriving');
      scene?.classList.add('is-pushing');
    }
    function renderRecipientContext() {
      const contextLabels = {
        mum: text('recipientContextMum', 'Mum'),
        loved: text('recipientContextLoved', 'someone you love'),
        friend: text('recipientContextFriend', 'your friend'),
        myself: text('recipientContextMyself', 'you')
      };
      $('[data-recipient-context]').textContent = text('recipientContext', 'A small feeling, chosen for {recipient}.', { recipient: contextLabels[selection.recipient] });
    }
    function renderSelection() {
      const scent = scents[selection.scent];
      $('[data-match-name]').textContent = scent.name;
      $('[data-match-notes]').textContent = scent.notes;
      $('[data-match-reason]').textContent = scent.reason;
      $('[data-match-intro]').textContent = text('matchIntro', '{feeling}, in scent.', { feeling: feelings[selection.feeling]?.label || '' });
      const form = $('[data-journey-form]');
      form.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === selection.format; });
      updateCommerce(form, selection.scent, selection.format);
    }
    function showStep(number, focus = true) {
      if (!journey) return;
      journeyStep = Math.max(1, Math.min(4, number));
      if (journeyStep === 2) renderRecipientContext();
      screens.forEach(screen => { screen.hidden = Number(screen.dataset.journeyStep) !== journeyStep; });
      $$('[data-progress-step]').forEach(item => {
        if (Number(item.dataset.progressStep) === journeyStep) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      $('[data-journey-progress]').textContent = text('journeyProgress', 'A gift for someone · {step} of 4', { step: journeyStep });
      $('[data-journey-back]').hidden = journeyStep === 1;
      if (journeyStep === 3) renderSelection();
      const screen = screens.find(item => Number(item.dataset.journeyStep) === journeyStep);
      animateScene(screen);
      if (focus && journey.open) {
        journey.scrollTop = 0;
        screen.querySelector('h2')?.focus({ preventScroll: true });
      }
    }
    function beginJourney(trigger) {
      editingKey = null;
      selection = { recipient: 'loved', feeling: 'calm', scent: 'white-tea', format: 'candle' };
      showStep(1, false);
      openDialog(journey, trigger, $('[data-journey-step="1"] h2'));
    }
    $$('[data-journey-open]').forEach(trigger => on(trigger, 'click', event => {
      if (!journey || typeof journey.showModal !== 'function') return;
      event.preventDefault(); beginJourney(trigger);
    }));
    $$('[data-explore-sets]').forEach(link => on(link, 'click', event => {
      const target = $('[data-gift-sets]');
      if (!target) return;
      event.preventDefault();
      const dialog = link.closest('dialog');
      if (dialog) { returns.set(dialog, target.querySelector('h2')); dialog.close(); }
      const disclosure = target.closest('details'); if (disclosure) disclosure.open = true;
      target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      target.querySelector('h2')?.focus({ preventScroll: true });
    }));
    $$('[data-catalog-jump]').forEach(link => on(link, 'click', event => {
      const hash = link.getAttribute('href');
      if (!hash?.startsWith('#')) return;
      let id; try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
      const target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
      target.focus({ preventScroll: true });
    }));
    $$('[data-recipient]').forEach(button => on(button, 'click', () => {
      selection.recipient = button.dataset.recipient; showStep(2);
    }));
    $$('[data-feeling]').forEach(button => on(button, 'click', () => {
      selection.feeling = button.dataset.feeling;
      selection.scent = feelings[selection.feeling].scent;
      showStep(3);
    }));
    on($('[data-journey-back]'), 'click', () => showStep(journeyStep === 4 ? 3 : journeyStep - 1));
    on($('[data-journey-reset]'), 'click', () => {
      editingKey = null;
      selection = { recipient: 'loved', feeling: 'calm', scent: 'white-tea', format: 'candle' };
      showStep(1);
    });
    on($('[data-journey-form]'), 'change', event => {
      if (!event.target.matches('input[type="radio"]') || !validFormat(event.target.value)) return;
      selection.format = event.target.value;
      updateCommerce($('[data-journey-form]'), selection.scent, selection.format);
    });
    function keepGift(gift, replaceKey = null) {
      if (replaceKey) state.gifts = state.gifts.filter(item => giftKey(item) !== replaceKey);
      const key = giftKey(gift);
      const index = state.gifts.findIndex(item => giftKey(item) === key);
      if (index >= 0) state.gifts[index] = { ...gift };
      else state.gifts.push({ ...gift });
      const saved = persist();
      renderGifts();
      root.dispatchEvent(new CustomEvent('lynk:gift-saved', { bubbles: true, detail: { kind: gift.kind === 'set' ? 'set' : 'single', tier: gift.tier, scent: gift.scent, format: gift.format } }));
      return saved;
    }
    on($('[data-journey-form]'), 'submit', event => {
      event.preventDefault();
      const saved = keepGift(selection, editingKey);
      editingKey = giftKey(selection);
      const format = formats[selection.format];
      $('[data-journey-summary]').textContent = text('giftSummary', '{scent} · {format} · {size}', { scent: scents[selection.scent].name, format: format.name, size: format.size });
      $('[data-journey-feedback]').textContent = saved
        ? text('savedForLater', 'Saved in this browser, ready to return to.')
        : text('savedVisitOnly', 'Kept for this visit. This browser could not save it for later.');
      const details = $('[data-journey-product]');
      const url = safeUrl(scents[selection.scent]?.productMappings?.[selection.format]?.url);
      if (details) { details.hidden = !url; if (url) details.href = url; }
      showStep(4);
    });

    function selectScent(key, shouldFocus = false) {
      if (!validScent(key)) return;
      currentScent = key;
      root.dataset.currentScent = key;
      $$('[data-story]').forEach(story => {
        story.hidden = story.dataset.story !== key;
        story.classList.remove('is-arriving');
        if (!story.hidden) {
          if (!reduced.matches) { void story.offsetWidth; story.classList.add('is-arriving'); }
          if (shouldFocus) story.querySelector('h3')?.focus({ preventScroll: true });
        }
      });
      $$('[data-scent]').forEach(link => {
        if (link.dataset.scent === key) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      setSelection.scent = resolveSetScent(setSelection.tier, key);
      renderSetChooser();
    }
    $$('[data-scent]').forEach(link => on(link, 'click', event => {
      event.preventDefault(); selectScent(link.dataset.scent, true);
      if (window.innerWidth <= 640) {
        $('[data-scent-stories]')?.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      }
    }));
    const scentForms = $$('[data-scent-form]');
    let restoredChoiceFrame = 0;
    function checkedFormat(form) {
      const checked = form.querySelector('input[type="radio"]:checked');
      return validFormat(checked?.value) ? checked.value : 'candle';
    }
    function syncScentForm(form) {
      const key = form.dataset.scentForm;
      if (!validScent(key)) return;
      const format = checkedFormat(form);
      form.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === format; });
      const standard = form.querySelector('[data-standard-link]');
      if (standard) standard.href = safeUrl(scents[key].standardProducts?.[format]) || 'https://lynkfragrances.com/';
      updateCommerce(form, key, format);
    }
    scentForms.forEach(form => {
      const key = form.dataset.scentForm;
      if (!validScent(key)) return;
      on(form, 'change', event => {
        if (!event.target.matches('input[type="radio"]') || !validFormat(event.target.value)) return;
        syncScentForm(form);
        form.querySelector('[data-choice-feedback]').textContent = '';
      });
      on(form, 'submit', event => {
        event.preventDefault();
        const gift = { scent: key, format: checkedFormat(form), recipient: 'loved', feeling: scents[key].feeling };
        const saved = keepGift(gift);
        form.querySelector('[data-choice-feedback]').textContent = saved
          ? text('savedMain', 'Saved. Find it under Saved ideas whenever you’re ready.')
          : text('savedVisitOnly', 'Kept for this visit. This browser could not save it for later.');
      });
      syncScentForm(form);
    });
    // History restoration can restore native checked inputs after initialization.
    // Reconcile on the next frame, once the browser has applied persisted form state.
    on(window, 'pageshow', () => {
      if (restoredChoiceFrame) cancelAnimationFrame(restoredChoiceFrame);
      restoredChoiceFrame = requestAnimationFrame(() => {
        restoredChoiceFrame = 0;
        if (!signal.aborted) scentForms.forEach(syncScentForm);
      });
    });

    function setMapping(tier, scent, choices) {
      if (componentSet(tier)) return componentMapping(tier, choices);
      if (setMode(tier) === 'pending') return undefined;
      return data.giftSetMappings?.[tier]?.[resolveSetScent(tier, scent)];
    }
    function hasSetPrice(tier, scent, choices) {
      const mapping = setMapping(tier, scent, choices);
      return mapping?.configured === true && typeof mapping.price === 'string' && mapping.price.trim().length > 0;
    }
    function setPrice(tier, scent, choices) {
      if (componentSet(tier) && data.boxedSetProducts?.[tier]?.configured && !hasSetPrice(tier, scent, choices)) return text('v34ChooseScents', 'Choose your scents');
      return hasSetPrice(tier, scent, choices) ? setMapping(tier, scent, choices).price : giftSets[tier]?.price || text('conceptPrice', 'Coming soon');
    }
    function formatLine(key) {
      const format = formats[key];
      return format.name + ' · ' + format.size + (format.detail ? ' · ' + format.detail : '');
    }
    function tierContents(tier) {
      const custom = Array.isArray(tier.contents) ? tier.contents : typeof tier.contents === 'string' ? tier.contents.split(/\r?\n/) : null;
      return custom ? custom.filter(value => typeof value === 'string').map(value => value.trim()).filter(Boolean) : tier.formats.map(formatLine);
    }
    function updateTierImage(image, tier) {
      if (!image) return;
      const url = safeUrl(tier.image);
      image.hidden = !url;
      if (url) { image.src = url; image.alt = tier.name; }
      else { image.removeAttribute('src'); image.alt = ''; }
    }
    function renderTierContent() {
      $$('[data-set-tier-name]').forEach(item => { const tier = giftSets[item.dataset.setTierName]; if (tier) item.textContent = tier.name; });
      $$('[data-set-tier-description]').forEach(item => { const tier = giftSets[item.dataset.setTierDescription]; if (tier) item.textContent = tier.description || ''; });
      $$('[data-set-tier-contents]').forEach(item => {
        const tier = giftSets[item.dataset.setTierContents]; if (!tier) return;
        if (['UL', 'OL'].includes(item.tagName)) item.replaceChildren(...tierContents(tier).map(line => element('li', '', line)));
        else item.textContent = tierContents(tier).join(' + ');
      });
      $$('[data-set-tier-image]').forEach(image => { const tier = giftSets[image.dataset.setTierImage]; if (tier) updateTierImage(image, tier); });
    }
    function addFinderSets() {
      const result = $('[data-finder-step="3"]');
      if (!result || result.querySelector('[data-finder-sets]')) return;
      const group = element('div', 'lgf-set-ideas'); group.dataset.finderSets = '';
      group.append(element('h3', '', text('setFinderHeading', 'Explore the Christmas gift sets')));
      group.append(element('p', 'lgf-note', text('setFinderNote', 'Explore the three Christmas gift sets. Choose scents for the boxed sets, or save an idea for later.')));
      Object.keys(giftSets).forEach(key => { const button = element('button', 'lgf-link', giftSets[key].name); button.type = 'button'; button.dataset.setOpen = key; button.dataset.setTierName = key; group.append(button); });
      result.insertBefore(group, result.querySelector('details'));
    }
    function setStatus(tier, scent, choices) {
      const mapping = setMapping(tier, scent, choices);
      if (componentSet(tier) && data.boxedSetProducts?.[tier]?.configured && !mapping) return completeChoices(tier, choices) ? text('v34CombinationUnavailable', 'This combination is unavailable. Try another selection.') : text('v34ChooseScents', 'Choose your scents');
      return mapping?.configured === true ? mapping.available === true ? text('v34Available', 'Available') : text('v34SoldOut', 'Sold out') : text('v34ComingSoon', 'Coming soon');
    }
    function renderSetChooser() {
      if (!setDialog || !validTier(setSelection.tier) || !validScent(setSelection.scent)) return;
      setSelection.scent = resolveSetScent(setSelection.tier, setSelection.scent);
      if (componentSet(setSelection.tier)) setSelection.choices = componentChoices(setSelection.tier, setSelection.choices);
      renderComponentChoices(setSelection.tier);
      const tier = giftSets[setSelection.tier], mode = setMode(setSelection.tier);
      renderTierContent();
      const description = $('[data-set-description]'); if (description) { description.textContent = tier.description || ''; description.hidden = !tier.description; }
      updateTierImage($('[data-set-image]'), tier);
      const caption = $('[data-set-image-caption]'); if (caption) { caption.textContent = tier.imageCaption || ''; caption.hidden = !tier.imageCaption; }
      setDialog.dataset.tier = setSelection.tier;
      $('[data-set-title]').textContent = tier.name;
      $('[data-set-price]').textContent = setPrice(setSelection.tier, setSelection.scent, setSelection.choices);
      const status = $('[data-set-status]'); if (status) status.textContent = setStatus(setSelection.tier, setSelection.scent, setSelection.choices);
      $('[data-set-contents]').replaceChildren(...tierContents(tier).map(line => element('li', '', line)));
      const fieldset = $('[data-set-scent-fieldset]'); if (fieldset) fieldset.hidden = mode !== 'one-scent';
      const oneScentNote = $('[data-set-one-scent]'); if (oneScentNote) oneScentNote.hidden = mode !== 'one-scent';
      const summary = $('[data-set-scent-summary]'); if (summary) { summary.hidden = mode === 'one-scent' || mode === 'components'; summary.textContent = mode === 'all-three' ? text('v34AllScents', 'Includes all three Christmas scents.') : mode === 'pending' ? text('v34PendingScents', 'Scents shown in the photograph.') : text('v34FixedScents', 'Scents as shown.'); }
      $$('[data-set-scent]').forEach(input => { input.checked = input.value === setSelection.scent; input.disabled = mode !== 'one-scent'; });
      const scentContext = $('[data-sets-current-scent]'); if (scentContext) scentContext.textContent = scents[currentScent].name;
      $$('[data-set-tier-price]').forEach(item => { if (validTier(item.dataset.setTierPrice)) item.textContent = setPrice(item.dataset.setTierPrice, currentScent); });
      $$('[data-set-tier-status]').forEach(item => { if (validTier(item.dataset.setTierStatus)) item.textContent = setStatus(item.dataset.setTierStatus, currentScent); });
      const nativePrices = Object.keys(giftSets).filter(key => hasSetPrice(key, currentScent)).length, pricingNote = $('[data-set-pricing-note]');
      const configuredComponents = Object.keys(giftSets).some(key => componentSet(key) && data.boxedSetProducts?.[key]?.configured === true);
      if (pricingNote) pricingNote.textContent = configuredComponents ? text('v34ComponentPrices', 'Boxed sets: choose each product’s scent to see the current price and availability. Saving places no order.') : nativePrices ? text('v34CurrentPrices', 'Listed sets show their current Shopify price. Saving an idea places no order.') : text('v34PreviewPrices', 'Choose scents for the boxed sets, or save an idea for later. Saving places no order.');
      $('[data-set-price-note]').textContent = mode === 'components' && data.boxedSetProducts?.[setSelection.tier]?.configured && !hasSetPrice(setSelection.tier, setSelection.scent, setSelection.choices) ? text('v34ChoiceIncomplete', 'Choose each product’s scent to see its current price and availability.') : hasSetPrice(setSelection.tier, setSelection.scent, setSelection.choices) ? text('v34CurrentPriceNote', 'Current Shopify price for this set. Saving keeps an idea in this browser; no order is placed.') : text('v34PreviewPriceNote', 'Coming soon. Save an idea for later; no order is placed.');
      updateCommerce($('[data-set-form]'), setSelection.scent, null, setMapping(setSelection.tier, setSelection.scent, setSelection.choices));
    }
    function openSet(tier, trigger, scent = currentScent, replaceKey = null, choices = null) {
      if (!setDialog || typeof tier !== 'string' || !validTier(tier) || typeof scent !== 'string' || !validScent(scent)) return false;
      setSelection = { tier, scent: resolveSetScent(tier, scent), ...(componentSet(tier) ? { choices: componentChoices(tier, choices || state.setChoices[tier]) } : {}) }; setEditingKey = replaceKey;
      if (fixedSet(tier) || componentSet(tier) || setMode(tier) === 'pending') renderSetChooser(); else selectScent(scent);
      $('[data-set-feedback]').textContent = '';
      return openDialog(setDialog, trigger);
    }
    addFinderSets();
    on(root, 'click', event => {
      const button = event.target.closest('[data-set-open]');
      if (!button || !root.contains(button)) return;
      const finder = button.closest('[data-gift-finder]');
      const feeling = finder?.lynkGiftFinderApi?.getState()?.feeling;
      const scent = finder ? feelings[feeling]?.scent || currentScent : currentScent;
      openSet(button.dataset.setOpen, button, scent);
    });
    on($('[data-set-form]'), 'change', event => {
      if (event.target.matches('[data-set-component]') && componentSet(setSelection.tier)) {
        const part = componentSpecs(setSelection.tier).find(item => item.key === event.target.dataset.setComponent);
        if (!part || (event.target.value !== '' && !part.values.includes(event.target.value))) return;
        setSelection.choices = componentChoices(setSelection.tier, { ...setSelection.choices, [part.key]: event.target.value });
        state.setChoices[setSelection.tier] = { ...setSelection.choices }; persist(); renderSetChooser();
        $('[data-set-feedback]').textContent = ''; return;
      }
      if (!event.target.matches('[data-set-scent]') || !validScent(event.target.value) || setMode(setSelection.tier) !== 'one-scent') return;
      selectScent(event.target.value);
      $('[data-set-feedback]').textContent = '';
    });
    on($('[data-set-form]'), 'submit', event => {
      event.preventDefault();
      const gift = { kind: 'set', tier: setSelection.tier, scent: resolveSetScent(setSelection.tier, setSelection.scent), ...(componentSet(setSelection.tier) ? { choices: componentChoices(setSelection.tier, setSelection.choices) } : {}) };
      const saved = keepGift(gift, setEditingKey);
      if (setEditingKey) setEditingKey = giftKey(gift);
      $('[data-set-feedback]').textContent = saved
        ? text('setSaved', 'Saved. Find this set under Saved ideas whenever you’re ready.')
        : text('savedVisitOnly', 'Kept for this visit. This browser could not save it for later.');
    });

    function renderGifts() {
      $$('[data-gift-count]').forEach(item => { item.textContent = String(state.gifts.length); });
      const empty = $('[data-gifts-empty]');
      if (empty) empty.hidden = state.gifts.length > 0;
      const list = $('[data-saved-list]');
      if (!list) return;
      list.replaceChildren();
      state.gifts.forEach(gift => {
        const item = element('li', 'lc-saved-item');
        const copy = element('div');
        const isSet = gift.kind === 'set';
        const format = isSet ? null : formats[gift.format];
        if (isSet) {
          const tier = giftSets[gift.tier];
          copy.append(element('h3', '', tier.name));
          copy.append(element('p', '', setScentLabel(gift.tier, gift.scent, gift.choices)));
          if (tier.description) copy.append(element('p', '', tier.description));
          copy.append(element('p', '', tierContents(tier).join(' + ')));
          if (safeUrl(tier.image)) { const image = element('img'); image.width = 240; image.loading = 'lazy'; updateTierImage(image, tier); copy.append(image); }
          if (setMode(gift.tier) === 'one-scent') copy.append(element('small', '', text('setOneScent', 'One scent throughout.')));
          const price = setPrice(gift.tier, gift.scent, gift.choices);
          copy.append(element('p', 'lc-saved-price', price));
        } else {
          copy.append(element('h3', '', scents[gift.scent].name));
          copy.append(element('p', '', text('giftSummary', '{scent} · {format} · {size}', { scent: scents[gift.scent].notes, format: format.name, size: format.size })));
          if (format.detail) copy.append(element('p', '', format.detail));
          copy.append(element('small', '', text('savedRecipient', 'For {recipient}', { recipient: recipients[gift.recipient] })));
        }
        const actions = element('div', 'lc-saved-actions');
        const savedMapping = isSet ? setMapping(gift.tier, gift.scent, gift.choices) : scents[gift.scent]?.productMappings?.[gift.format];
        if (safeUrl(savedMapping?.url)) {
          const details = actionLink('a', 'lc-product-link', text('viewProduct', 'View product details ↗'));
          details.href = safeUrl(savedMapping.url); actions.append(details);
        }
        const edit = element('button', 'lc-text-link', text('edit', 'Edit'));
        edit.type = 'button'; edit.dataset.editGift = giftKey(gift);
        edit.setAttribute('aria-label', isSet
          ? text('editSet', 'Edit {set} in {scent}', { set: giftSets[gift.tier].name, scent: setScentLabel(gift.tier, gift.scent, gift.choices) })
          : text('editGift', 'Edit {scent}, {format}', { scent: scents[gift.scent].name, format: format.name }));
        const remove = element('button', 'lc-text-link', text('remove', 'Remove'));
        remove.type = 'button'; remove.dataset.removeGift = giftKey(gift);
        remove.setAttribute('aria-label', isSet
          ? text('removeSet', 'Remove {set} in {scent}', { set: giftSets[gift.tier].name, scent: setScentLabel(gift.tier, gift.scent, gift.choices) })
          : text('removeGift', 'Remove {scent}, {format}', { scent: scents[gift.scent].name, format: format.name }));
        actions.append(edit, remove); item.append(copy, actions); list.append(item);
      });
    }
    $$('[data-gift-open]').forEach(button => on(button, 'click', () => {
      renderGifts(); $('[data-saved-feedback]').textContent = ''; openDialog(giftDialog, button);
    }));
    on($('[data-saved-list]'), 'click', event => {
      const edit = event.target.closest('[data-edit-gift]');
      const remove = event.target.closest('[data-remove-gift]');
      if (edit) {
        const gift = state.gifts.find(item => giftKey(item) === edit.dataset.editGift);
        if (!gift) return;
        if (gift.kind === 'set') { openSet(gift.tier, edit, gift.scent, giftKey(gift), gift.choices); return; }
        selection = { ...gift }; editingKey = giftKey(gift); showStep(3, false);
        openDialog(journey, edit, $('[data-journey-step="3"] h2'));
      }
      if (remove) {
        const index = state.gifts.findIndex(item => giftKey(item) === remove.dataset.removeGift);
        if (index < 0) return;
        const gift = state.gifts[index];
        state.gifts.splice(index, 1);
        const saved = persist(); renderGifts();
        $('[data-saved-feedback]').textContent = saved
          ? text('removedGift', '{scent} removed from your saved ideas.', { scent: gift.kind === 'set' ? giftSets[gift.tier].name : scents[gift.scent].name })
          : text('removedVisitOnly', 'Removed for this visit. This browser could not update the saved list.');
        const following = $('[data-saved-list]').querySelectorAll('[data-remove-gift]');
        (following[Math.min(index, following.length - 1)] || $('[data-gift-dialog] [data-find-gift]') || $('[data-gift-dialog] [data-journey-open]'))?.focus();
      }
    });

    function letterValues() {
      return { to: $('[data-letter-to]').value.slice(0, 60), from: $('[data-letter-from]').value.slice(0, 80), message: $('[data-letter-message]').value.slice(0, 1500) };
    }
    function letterText() {
      const to = state.letter.to.trim() || text('someoneSpecial', 'Someone special');
      const from = state.letter.from.trim();
      return text('letterDear', 'Dear {recipient},', { recipient: to }) + '\n\n' + state.letter.message + '\n\n' + text('letterWithLove', 'With love,') + (from ? '\n' + from : '');
    }
    function openLetter(recipient, trigger) {
      if (!letterDialog || typeof recipient !== 'string' || !validRecipient(recipient)) return false;
      const template = letterTemplates[recipient] || letterTemplates.mum;
      if (!state.letterCustomized) {
        state.letter = { to: template.to, from: '', message: template.message };
        state.letterRecipient = recipient;
        persist();
      }
      $('[data-letter-to]').value = state.letter.to;
      $('[data-letter-from]').value = state.letter.from;
      $('[data-letter-message]').value = state.letter.message;
      $('[data-letter-form]').hidden = false;
      $('[data-letter-output]').hidden = true;
      return openDialog(letterDialog, trigger);
    }
    $$('[data-letter-open]').forEach(button => on(button, 'click', () => openLetter(journey?.open ? selection.recipient : 'mum', button)));
    on($('[data-letter-form]'), 'input', () => { state.letter = letterValues(); state.letterCustomized = true; persist(); });
    on($('[data-letter-form]'), 'submit', event => {
      event.preventDefault(); state.letter = letterValues();
      const template = letterTemplates[state.letterRecipient] || letterTemplates.mum;
      state.letterCustomized = state.letterCustomized || state.letter.to !== template.to || state.letter.message !== template.message || !!state.letter.from;
      const saved = persist();
      $('[data-output-to]').textContent = text('letterDear', 'Dear {recipient},', { recipient: state.letter.to.trim() || text('someoneSpecial', 'Someone special') });
      $('[data-output-message]').textContent = state.letter.message;
      $('[data-output-from]').textContent = text('letterWithLove', 'With love,') + (state.letter.from.trim() ? '\n' + state.letter.from.trim() : '');
      $('[data-letter-form]').hidden = true;
      $('[data-letter-output]').hidden = false;
      $('[data-letter-feedback]').textContent = saved ? '' : text('letterVisitOnly', 'Your words are kept for this visit. This browser could not save them for later.');
      $('[data-letter-edit]').focus();
      letterDialog.scrollTop = 0;
    });
    on($('[data-letter-edit]'), 'click', () => {
      $('[data-letter-output]').hidden = true; $('[data-letter-form]').hidden = false;
      $('[data-letter-message]').focus();
    });
    on($('[data-letter-copy]'), 'click', async () => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(letterText());
        $('[data-letter-feedback]').textContent = text('letterCopied', 'Copied, ready to share.');
      } catch (_) {
        $('[data-letter-feedback]').textContent = text('letterCopyFallback', 'Select your letter above to copy your words.');
        const selectionRange = window.getSelection();
        const range = document.createRange();
        range.setStartBefore($('[data-output-to]')); range.setEndAfter($('[data-output-from]'));
        selectionRange?.removeAllRanges(); selectionRange?.addRange(range);
      }
    });

    $$('[data-film-story-open]').forEach(link => on(link, 'click', event => {
      if (!storyDialog || typeof storyDialog.showModal !== 'function') return;
      event.preventDefault(); openDialog(storyDialog, link);
    }));
    $$('[data-chapter]').forEach(button => on(button, 'click', () => {
      const chapter = data.chapters[button.dataset.chapter];
      if (!chapter) return;
      $$('[data-chapter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      $('[data-storyboard-image]').src = safeUrl(chapter.src) || chapter.src;
      $('[data-storyboard-image]').alt = chapter.alt;
      $('[data-storyboard-caption]').textContent = chapter.caption;
    }));
    const config = merge(window.LYNK_CAMPAIGN || {}, { filmSrc: data.filmSrc ?? (window.LYNK_CAMPAIGN || {}).filmSrc, filmPoster: data.filmPoster ?? (window.LYNK_CAMPAIGN || {}).filmPoster });
    const filmSrc = safeUrl(config.filmSrc);
    const film = $('[data-campaign-video]');
    if (filmSrc && film) {
      film.src = filmSrc;
      film.poster = safeUrl(config.filmPoster) || film.poster;
      film.hidden = false;
      $('[data-film]').classList.add('has-film');
      $('[data-film-status]').textContent = text('actualFilm', 'The Last Gift · A fictional Christmas story from Lynk.');
      $('[data-storyboard-status]').textContent = text('actualStoryboard', 'Painted storyboards for our fictional Christmas film.');
      on(film, 'error', () => {
        film.hidden = true;
        $('[data-film]').classList.remove('has-film');
        $('[data-film-status]').textContent = text('filmError', 'The film could not load. You can still explore its story below.');
      });
    }
    if (data.assets?.courtyard) {
      const url = safeUrl(data.assets.courtyard);
      if (url) root.style.setProperty('--lc-courtyard-image', 'url(' + JSON.stringify(url) + ')');
    }

    /* Optional real Shopify mapping. A saved thought remains independent of a cart. */
    function updateCommerce(form, scentKey, formatKey, mappedSet) {
      if (!form) return;
      let holder = form.querySelector('[data-commerce]');
      if (!holder) {
        holder = element('div', 'lc-commerce'); holder.dataset.commerce = ''; form.insertBefore(holder, form.querySelector('[data-save-gift], [data-journey-save], [data-set-save]'));
      }
      holder.replaceChildren();
      const mapping = mappedSet || scents[scentKey]?.productMappings?.[formatKey];
      if (data.mode !== 'shopify') {
        if (!mapping || !safeUrl(mapping.url)) return;
        const link = actionLink('a', 'lc-product-link', text('viewProduct', 'View this product on Lynk ↗'));
        link.href = safeUrl(mapping.url); holder.append(link); return;
      }
      if (mapping?.price) holder.append(element('p', 'lc-product-detail', String(mapping.price)));
      if (mapping?.variantTitle) holder.append(element('p', 'lc-product-detail', String(mapping.variantTitle)));
      // Product details remain usable independently of stock or cart availability.
      if (safeUrl(mapping?.url)) {
        const link = actionLink('a', 'lc-button lc-button-light', text('viewProduct', 'View product details ↗'));
        link.href = safeUrl(mapping.url); holder.append(link);
      }
      const buy = element('button', 'lc-button lc-button-light');
      buy.type = 'button'; buy.dataset.cartAdd = '';
      const configured = mapping?.configured === true && /^\d+$/.test(String(mapping.variantId || ''));
      buy.disabled = !configured || mapping.available !== true;
      buy.textContent = !configured ? text('notAvailable', 'Not yet available') : mapping.available !== true ? text('soldOut', 'Sold out') : text('addToBag', 'Add to bag');
      if (buy.disabled) { holder.append(buy); return; }
      const feedback = element('p', 'lc-feedback'); feedback.setAttribute('role', 'status');
      on(buy, 'click', async () => {
        const route = mapping.cartAddUrl || data.cartAddUrl;
        let endpoint;
        try { endpoint = new URL(route, location.origin); } catch (_) { endpoint = null; }
        if (!endpoint || !route || endpoint.origin !== location.origin) {
          feedback.textContent = text('cartUnavailable', 'The bag is unavailable here. Open the product on Lynk to continue.'); return;
        }
        buy.disabled = true; buy.textContent = text('addingToBag', 'Adding…');
        try {
          const response = await fetch(endpoint.href, {
            method: 'POST', credentials: 'same-origin', signal,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: String(mapping.variantId), quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : text('cartError', 'This item could not be added. Please try again.'));
          feedback.textContent = text('addedToBag', 'Added to your bag.');
          const cartUrl = safeUrl(mapping.cartUrl || data.cartUrl);
          if (cartUrl) {
            const view = actionLink('a', 'lc-product-link', text('viewBag', 'View bag ↗'));
            view.href = cartUrl; feedback.append(document.createTextNode(' '), view);
          }
          root.dispatchEvent(new CustomEvent('lynk:cart-added', { bubbles: true, detail: { variantId: mapping.variantId, result } }));
        } catch (error) {
          if (error.name !== 'AbortError') feedback.textContent = error.message || text('cartError', 'This item could not be added. Please try again.');
        } finally {
          buy.disabled = false; buy.textContent = text('addToBag', 'Add to bag');
        }
      });
      holder.append(buy, feedback);

    }

    let revealObserver;
    if ('IntersectionObserver' in window && !reduced.matches) {
      revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-seen'); revealObserver.unobserve(entry.target); }
        });
      }, { threshold: .13 });
      $$('[data-reveal]').forEach(item => revealObserver.observe(item));
    }
    /* Scroll-driven movement stays small; natural scrolling owns the page. */
    const hero = $('[data-hero]');
    const heroImage = $('[data-hero-image]');
    function applyParallax() {
      frame = 0;
      if (reduced.matches || window.innerWidth <= 640 || !hero || !heroImage) { if (heroImage) heroImage.style.transform = ''; return; }
      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      heroImage.style.transform = 'translateY(' + (progress * rect.height * .045).toFixed(1) + 'px) scale(1.015)';
    }
    function queueParallax() { if (!frame) frame = requestAnimationFrame(applyParallax); }
    on(window, 'scroll', queueParallax, { passive: true });
    on(window, 'resize', queueParallax, { passive: true });
    on(reduced, 'change', queueParallax);

    function revealHashDisclosure() {
      let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!id) return;
      const target = $$('[id]').find(item => item.id === id || item.id === prefix + '-' + id);
      if (!target) return;
      let parent = target.closest('details'), revealed = false;
      while (parent && root.contains(parent)) { if (!parent.open) revealed = true; parent.open = true; parent = parent.parentElement?.closest('details'); }
      if (id === 'christmas-products' || id === prefix + '-christmas-products') {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        target.focus({ preventScroll: true });
      } else if (revealed && target.matches('[data-gift-sets]')) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        target.querySelector('h2')?.focus({ preventScroll: true });
      }
    }
    on(window, 'hashchange', revealHashDisclosure);
    revealHashDisclosure();
    root.classList.add('is-enhanced');
    const hashStory = $$('[data-story]').find(story => '#' + story.id === location.hash);
    selectScent(hashStory?.dataset.story || currentScent);
    renderGifts();
    showStep(1, false);
    applyParallax();
    const api = {
      data,
      saveGift(gift) {
        if (signal.aborted) return { persisted: false };
        const clean = cleanGift(gift);
        return { persisted: clean ? keepGift(clean) : false };
      },
      getGifts() { return state.gifts.map(gift => ({ ...gift })); },
      openSet(tier, scent, trigger) { return !signal.aborted && typeof scent === 'string' && validScent(scent) ? openSet(tier, trigger, scent) : false; },
      openLetter(recipient, trigger) { return signal.aborted ? false : openLetter(recipient, trigger); },
      destroy() {
        controller.abort(); revealObserver?.disconnect();
        if (frame) cancelAnimationFrame(frame);
        if (restoredChoiceFrame) cancelAnimationFrame(restoredChoiceFrame);
        animations.forEach(animation => animation.cancel());
        $$('dialog[open]').forEach(dialog => dialog.close());
        film?.pause();
        heroImage?.style.removeProperty('transform');
        root.classList.remove('is-enhanced');
        $$('[data-story]').forEach(story => { story.hidden = false; });
        instances.delete(root);
        if (root.lynkChristmasApi === api) delete root.lynkChristmasApi;
      }
    };
    instances.set(root, api);
    root.lynkChristmasApi = api;
    root.dispatchEvent(new CustomEvent('lynk:ready', { bubbles: true }));
    return api;
  };

  function initializeIn(container) {
    if (container.matches?.('[data-lynk-christmas]')) window.initLynkChristmas(container);
    container.querySelectorAll?.('[data-lynk-christmas]').forEach(root => window.initLynkChristmas(root));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeIn(document), { once: true });
  else initializeIn(document);
  if (!window.__lynkChristmasLifecycle) {
    document.addEventListener('shopify:section:load', event => initializeIn(event.target));
    document.addEventListener('shopify:section:unload', event => {
      const container = event.target;
      if (container.matches?.('[data-lynk-christmas]')) instances.get(container)?.destroy();
      container.querySelectorAll?.('[data-lynk-christmas]').forEach(root => instances.get(root)?.destroy());
    });
    window.__lynkChristmasLifecycle = true;
  }
}());
